import type { ContractControllerGetContractsSortBy } from '@/generated/api/models';

// The contract list's URL/API contract: which column ids a stored view may
// reference (none stored yet — no ListViewBar for contracts in this pass)
// and which sort keys the backend accepts. The presentation side of the
// catalogue (cell renderers, filter wiring) lives in ../components/columns.tsx.
// `satisfies` against the generated sort type so a renamed/removed backend
// field fails to compile here instead of only failing at the API boundary.
export const CONTRACT_SORT_KEYS = [
  'name',
  'contractPartner',
  'startDate',
  'endDate',
  'contractKey',
  'externalContractNumber',
  // No backing column (Section 1: "Next end is not a column at all") — never
  // reachable by clicking a header, only as the leasing/insurance default
  // sort. Fully supported end-to-end by the backend already; see
  // ContractSortField in contract-vocabulary.ts.
  'nextEnd',
] as const satisfies readonly ContractControllerGetContractsSortBy[];

export const CONTRACT_COLUMN_IDS: readonly string[] = [
  'contractKey',
  'name',
  'vehicles',
  'contractPartner',
  'startDate',
  'endDate',
  'status',
  'paymentMethod',
  'externalContractNumber',
];

export const CONTRACT_TABS = ['purchase', 'leasing', 'insurance'] as const;
export type ContractTab = (typeof CONTRACT_TABS)[number];

// Mirrors the backend's NEXT_END_BUCKETS (contract-vocabulary.ts) — the
// derived-bucket filter "Next end" carries in place of being a column
// (Section 1: "no column at all"). Leasing/insurance tabs only; a purchase
// contract has no end concept.
export const CONTRACT_NEXT_END_BUCKETS = ['within90', 'within180', 'noEnd'] as const;
export type ContractNextEndBucket = (typeof CONTRACT_NEXT_END_BUCKETS)[number];

// The backend's closed status vocabulary — mirrors CONTRACT_STATUSES in
// contract-vocabulary.ts. Used to validate the URL's `status` filter before
// it reaches the typed API client (review finding, MR !131).
export const CONTRACT_STATUSES = ['active', 'ended'] as const;
